import { EventBus } from "../../../eventbus";

export default {
  props: {
    views: {
      type: Array,
      default: () => [],
    },
    activeView: String,
    searchSetting: {
      type: Object,
    },
    searchOptions: {
      type: Array,
      default: () => [],
    },
    fileCount: Number,
    parenId: String,
    searchOptionsEmitterName: String,
    selectAllEmitterName: String,
  },
  data() {
    return {
      id: this.$options.name,
      checked: false,
    };
  },
  created() {
    this.setChecked();

    EventBus.$on(`${this.id}-updateSelected`, this.setChecked);
  },
  methods: {
    selectAll() {
      EventBus.$emit(`${this.parenId}-selectAll`, { checked: !this.checked });
      //EventBus.$emit(`closeallactions`);
    },
    sortBy(sortKey) {
      EventBus.$emit(`${this.parenId}-updatedSearchSettings`, {
        sortKey,
      });
    },
    toggleView(view) {
      EventBus.$emit(`${this.parenId}-updateView`, {
        view,
      });
    },
    setChecked() {
      this.checked =
        this.$store.state.transferItems.selectedFiles.length +
          this.$store.state.transferItems.selectedFolders.length ===
          this.fileCount && this.fileCount > 0;
    },
  },
  watch: {
    activeView() {},
    searchSetting() {},
    $route() {
      this.setChecked();
    },
    "$store.state.transferItems"() {
      this.setChecked();
    },
  },
};
